import { render } from "./review.vue?vue&type=template&id=1f370dfe"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"
script.render = render

export default script